// @ts-nocheck
import Events from '../constants/events';
import { handleError } from '../utilities';
import { siteApi } from '../services';

export default new Proxy(
  {
    events: Object.fromEntries(
      Object.entries(Events).filter(([, value]) =>
        value.startsWith('concord-profile'),
      ),
    ),
    update: async (profile) => {
      if (Object.values(profile).some((v) => !!v)) {
        try {
          await siteApi.postProfile(profile);
          return true;
        } catch (err) {
          handleError(err);
          throw err;
        }
      }
      return false;
    },
  },
  {
    set: () => false,
  },
);
